var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapPinFilledinline = function SvgMapPinFilledinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C7.5 0 3.8 3.7 3.8 8.2S12 24 12 24s8.2-11.2 8.2-15.8S16.5 0 12 0zm0 12.5c-2.4 0-4.3-1.9-4.3-4.3C7.7 5.9 9.6 4 12 4s4.3 1.9 4.3 4.3c0 2.3-1.9 4.2-4.3 4.2z"
  })));
};

export default SvgMapPinFilledinline;